var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_197)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2256_197",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H0V27H27V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2256_197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6875 5.625H4.31244C3.96435 5.625 3.6305 5.76329 3.38436 6.00942C3.13822 6.25556 2.99994 6.58941 2.99994 6.9375V20.0625C2.99994 20.4106 3.13822 20.7445 3.38436 20.9906C3.6305 21.2368 3.96435 21.375 4.31244 21.375H22.6875C23.0356 21.375 23.3695 21.2368 23.6156 20.9906C23.8617 20.7445 24 20.4106 24 20.0625V6.9375C24 6.58941 23.8617 6.25556 23.6156 6.00942C23.3695 5.76329 23.0356 5.625 22.6875 5.625ZM21.6768 20.0625H5.40182L9.99558 15.3113L9.05058 14.3991L4.31244 19.3013V7.935L12.4696 16.0528C12.7155 16.2973 13.0482 16.4345 13.395 16.4345C13.7417 16.4345 14.0744 16.2973 14.3203 16.0528L22.6875 7.73157V19.216L17.8575 14.386L16.9322 15.3113L21.6768 20.0625ZM5.17213 6.9375H21.6243L13.395 15.121L5.17213 6.9375Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.40379011333d4264d1f1803a7182cf84.svg";
export { ForwardRef as ReactComponent };